import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "Our Procurement Services are designed to ensure timely, cost-efficient, and quality-assured sourcing of materials, equipment, and services essential for project success.",
  paragraphs: [
    "Jeyshawn Engineering Limited maintains strong relationships with reputable international and local suppliers, enabling us to source and deliver high-quality materials and equipment that meet project specifications and regulatory requirements.",
    "Our procurement team manages the full supply chain lifecycle — from vendor qualification and tendering to expediting, logistics, inspection, and delivery. We prioritize quality control, cost management, and schedule adherence at every stage.",
    "We leverage our extensive vendor network and market knowledge to deliver competitive procurement solutions that reduce project costs and risks while ensuring compliance with client and industry standards.",
  ],
  sections: [],
};

export default function Procurement() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/procurement", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || null;
  const bgImg     = resolveUrl(pageData.bgImage)     || null;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Procurement" />
      )}

      {bannerImg && (
        <div className="img_carrier">
          <img src={bannerImg} alt="" />
        </div>
      )}

      <section className="service-detail" style={bgImg ? { backgroundImage: `url(${bgImg})` } : {}}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
